import { createSlice } from '@reduxjs/toolkit';
import FieldNames from '../../defaults/FieldNames.json';
import { getFilterExpressionStringFromRedux } from '../../utils/ExpressionHelper';
import { setCurrentMapViewObj } from './mapSlice';
import { setConfig, setNifcToken, setRootServiceUrl } from './configurationSlice';

export const initialState = {
    isQuerying: false,
    isEstimatedTreatmentQuerying: false,
    isEstimatedActivityQuerying: false,
    isActualTreatmentQuerying: false,
    isActualActivityQuerying: false,
    isPostFireProjectQuerying: false,
    isBasicFilterActive: true,
    isCustomFilterActive: false,
    activeFilterCount: 0,
    class: null,
    filterProjectValue: [],
    projectDiscoveryDates: [],
    projectFireCodes: [],
    projectIDs: [],
    fuelsCategories: [],
    postFireCategories: [],
    minDurability: null,
    maxDurability: null,
    priorities: [],
    minCalculatedArea: null,
    maxCalculatedArea: null,
    calculatedAreaType: null,
    fundingUnitType: [],
    fundingUnitTypeIgnoreNational: false,
    ignoreContributedOnly: false,
    fundingSubUnit: [],
    fundingTribe: [],
    fundingUnit: [],
    fundingDepartment: [],
    fundingRegion: [],
    fundingAgency: [],
    congressionalDistrict: [],
    minInitiationDate: null,
    maxInitiationDate: null,
    minCompletionDate: null,
    maxCompletionDate: null,
    minEstPersonnelCost: null,
    maxEstPersonnelCost: null,
    minEstGrantsFixedCost: null,
    maxEstGrantsFixedCost: null,
    minEstAssetCost: null,
    maxEstAssetCost: null,
    minEstContractualCost: null,
    maxEstContractualCost: null,
    minEstOtherCost: null,
    maxEstOtherCost: null,
    minEstTotalCost: null,
    maxEstTotalCost: null,
    minFiscalYear: null,
    maxFiscalYear: null,
    minCompletionFiscalYear: null,
    maxCompletionFiscalYear: null,
    minObligationFiscalYear: null,
    maxObligationFiscalYear: null,
    minFiscalQuarter: null,
    maxFiscalQuarter: null,
    initiationFiscalQuarters: [],
    completionFiscalQuarters: [],
    states: [],
    counties: [],
    fuelsTypes: [],
    postFireTypes: [],
    wbsIds: [],
    isRTRL: [],
    isContract: [],
    isAgreement: [],
    status: [],
    isCarryover: false,
    fundingSources: [],
    definitionExpression: '',
    filterExpression: '',
    filterFeatureSelection: [],
    activeDrawTool: null,
    filterGeometry: null,
    isDepartmentApproved: null,
    isRegionApproved: null,
    isAgencyApproved: null,
    isLocalApproved: null,
    isAllApproved: false,
    isNoneApproved: false,
    isLocationFilterOnly: false,
    isGroupingOnly: false,
    names: [],
    dataset: '',
    isInteragency: null,
    customFilterCount: 0,

    // Updated from MapSlice
    currentMapExtent: null,
    currentMapScale: null,
    currentMapZoom: null,
    currentMapResolution: null,

    // Updated from configurationSlice
    rootServiceUrl: '',
    nifcToken: '',
    config: null,
};

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        clearFilters: (state) => {
            state.isQuerying = false;
            state.isEstimatedTreatmentQuerying = false;
            state.isEstimatedActivityQuerying = false;
            state.isActualTreatmentQuerying = false;
            state.isActualActivityQuerying = false;
            state.isPostFireProjectQuerying = false;
            state.isBasicFilterActive = true;
            state.isCustomFilterActive = false;
            state.activeFilterCount = 0;
            state.class = null;
            state.activeDrawTool = null;
            state.filterGeometry = null;
            state.filterProjectValue = [];
            state.projectDiscoveryDates = [];
            state.projectFireCodes = [];
            state.projectIDs = [];
            state.fuelsCategories = [];
            state.postFireCategories = [];
            state.minDurability = null;
            state.maxDurability = null;
            state.priorities = [];
            state.minCalculatedArea = null;
            state.maxCalculatedArea = null;
            state.calculatedAreaType = null;
            state.fundingSubUnit = [];
            state.fundingTribe = [];
            state.fundingUnit = [];
            state.fundingUnitType = [];
            state.fundingUnitTypeIgnoreNational = false;
            state.ignoreContributedOnly = false;
            state.fundingDepartment = [];
            state.fundingRegion = [];
            state.fundingAgency = [];
            state.congressionalDistrict = [];
            state.minInitiationDate = null;
            state.maxInitiationDate = null;
            state.minCompletionDate = null;
            state.maxCompletionDate = null;
            state.minEstPersonnelCost = null;
            state.maxEstPersonnelCost = null;
            state.minEstGrantsFixedCost = null;
            state.maxEstGrantsFixedCost = null;
            state.minEstAssetCost = null;
            state.maxEstAssetCost = null;
            state.minEstContractualCost = null;
            state.maxEstContractualCost = null;
            state.minEstOtherCost = null;
            state.maxEstOtherCost = null;
            state.minEstTotalCost = null;
            state.maxEstTotalCost = null;
            state.minFiscalYear = null;
            state.maxFiscalYear = null;
            state.minCompletionFiscalYear = null;
            state.maxCompletionFiscalYear = null;
            state.minObligationFiscalYear = null;
            state.maxObligationFiscalYear = null;
            state.completionFiscalQuarters = [];
            state.initiationFiscalQuarters = [];
            state.states = [];
            state.counties = [];
            state.fuelsTypes = [];
            state.postFireTypes = [];
            state.wbsIds = [];
            state.isRTRL = [];
            state.isContract = [];
            state.isAgreement = [];
            state.status = [];
            state.isCarryover = false;
            state.fundingSources = [];
            state.definitionExpression = '(OBJECTID IS NOT NULL)';
            state.filterExpression = '(OBJECTID IS NOT NULL)';
            state.filterFeatureSelection = [];
            state.isDepartmentApproved = null;
            state.isRegionApproved = null;
            state.isAgencyApproved = null;
            state.isLocalApproved = null;
            state.isAllApproved = false;
            state.isNoneApproved = false;
            state.isLocationFilterOnly = false;
            state.isGroupingOnly = false;
            state.names = [];
            state.dataset = '';
            state.isInteragency = null;
        },
       
        setIsEstimatedTreatmentQuerying: (state, action) => {
            state.isEstimatedTreatmentQuerying = action.payload;
            state.isQuerying =
                state.isEstimatedTreatmentQuerying ||
                state.isEstimatedActivityQuerying ||
                state.isActualTreatmentQuerying ||
                state.isActualActivityQuerying ||
                state.isPostFireProjectQuerying;
        },
        setIsEstimatedActivityQuerying: (state, action) => {
            state.isEstimatedActivityQuerying = action.payload;
            state.isQuerying =
                state.isEstimatedTreatmentQuerying ||
                state.isEstimatedActivityQuerying ||
                state.isActualTreatmentQuerying ||
                state.isActualActivityQuerying ||
                state.isPostFireProjectQuerying;
        },
        setIsActualTreatmentQuerying: (state, action) => {
            state.isActualTreatmentQuerying = action.payload;
            state.isQuerying =
                state.isEstimatedTreatmentQuerying ||
                state.isEstimatedActivityQuerying ||
                state.isActualTreatmentQuerying ||
                state.isActualActivityQuerying ||
                state.isPostFireProjectQuerying;
        },
        setIsActualActivityQuerying: (state, action) => {
            state.isActualActivityQuerying = action.payload;
            state.isQuerying =
                state.isEstimatedTreatmentQuerying ||
                state.isEstimatedActivityQuerying ||
                state.isActualTreatmentQuerying ||
                state.isActualActivityQuerying ||
                state.isPostFireProjectQuerying;
        },
        setIsPostFireProjectQuerying: (state, action) => {
            state.isPostFireProjectQuerying = action.payload;
            state.isQuerying =
                state.isEstimatedTreatmentQuerying ||
                state.isEstimatedActivityQuerying ||
                state.isActualTreatmentQuerying ||
                state.isActualActivityQuerying ||
                state.isPostFireProjectQuerying;
        },
        setIsBasicFilterActive: (state, action) => {
            state.isBasicFilterActive = action.payload;
        },
        setIsCustomFilterActive: (state, action) => {
            state.isCustomFilterActive = action.payload;
        },
        setCustomFilterCount: (state, action) => {
            state.customFilterCount = action.payload;
        },
        setFilterProjectValue: (state, action) => {
            state.filterProjectValue = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setProjectDiscoveryDates: (state, action) => {
            state.projectDiscoveryDates = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setProjectFireCodes: (state, action) => {
            state.projectFireCodes = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setProjectIDs: (state, action) => {
            state.projectIDs = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setPostFireCategories: (state, action) => {
            state.postFireCategories = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFuelsCategories: (state, action) => {
            state.fuelsCategories = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinDurability: (state, action) => {
            state.minDurability = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxDurability: (state, action) => {
            state.maxDurability = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setPriorities: (state, action) => {
            state.priorities = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setActiveDrawTool: (state, action) => {
            state.activeDrawTool = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFilterGeometry: (state, action) => {
            state.filterGeometry = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinCalculatedArea: (state, action) => {
            state.minCalculatedArea = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxCalculatedArea: (state, action) => {
            state.maxCalculatedArea = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setCalculatedAreaType: (state, action) => {
            state.calculatedAreaType = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setCongressionalDistrict: (state, action) => {
            state.congressionalDistrict = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinInitiationDate: (state, action) => {
            state.minInitiationDate = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxInitiationDate: (state, action) => {
            state.maxInitiationDate = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinCompletionDate: (state, action) => {
            state.minCompletionDate = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxCompletionDate: (state, action) => {
            state.maxCompletionDate = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinEstPersonnelCost: (state, action) => {
            state.minEstPersonnelCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxEstPersonnelCost: (state, action) => {
            state.maxEstPersonnelCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setEstPersonnelCost: (state, action) => {
            state.minEstPersonnelCost = action.payload[0];
            state.maxEstPersonnelCost = action.payload[1];
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinEstGrantsFixedCost: (state, action) => {
            state.minEstGrantsFixedCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxEstGrantsFixedCost: (state, action) => {
            state.maxEstGrantsFixedCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setEstGrantsFixedCost: (state, action) => {
            state.minEstGrantsFixedCost = action.payload[0];
            state.maxEstGrantsFixedCost = action.payload[1];
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinEstAssetCost: (state, action) => {
            state.minEstAssetCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxEstAssetCost: (state, action) => {
            state.maxEstAssetCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setEstAssetCost: (state, action) => {
            state.minEstAssetCost = action.payload[0];
            state.maxEstAssetCost = action.payload[1];
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinEstContractualCost: (state, action) => {
            state.minEstContractualCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxEstContractualCost: (state, action) => {
            state.maxEstContractualCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setEstContractualCost: (state, action) => {
            state.minEstContractualCost = action.payload[0];
            state.maxEstContractualCost = action.payload[1];
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinEstOtherCost: (state, action) => {
            state.minEstOtherCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxEstOtherCost: (state, action) => {
            state.maxEstOtherCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setEstOtherCost: (state, action) => {
            state.minEstOtherCost = action.payload[0];
            state.maxEstOtherCost = action.payload[1];
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinEstTotalCost: (state, action) => {
            state.minEstTotalCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxEstTotalCost: (state, action) => {
            state.maxEstTotalCost = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setEstTotalCost: (state, action) => {
            state.minEstTotalCost = action.payload[0];
            state.maxEstTotalCost = action.payload[1];
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        addState: (state, action) => {
            state.states = [...state.states, action.payload];
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setState: (state, action) => {
            state.states = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setCounty: (state, action) => {
            state.counties = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFuelsType: (state, action) => {
            state.fuelsTypes = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setPostFireType: (state, action) => {
            state.postFireTypes = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setWbsIds: (state, action) => {
            state.wbsIds = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsRTRL: (state, action) => {
            state.isRTRL = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsContract: (state, action) => {
            state.isContract = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsAgreement: (state, action) => {
            state.isAgreement = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setStatus: (state, action) => {
            state.status = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsCarryover: (state, action) => {
            state.isCarryover = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingSources: (state, action) => {
            state.fundingSources = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setDefinitionExpression: (state, action) => {
            state.definitionExpression = action.payload;
        },
        setFilterExpression: (state, action) => {
            //Setting this up so that we can only change the definition expression from a Search
            //button on filters instead of on every change to filters
            //without doing an entire system rework - FUELS-772
            state.filterExpression = action.payload;
        },
        setMinFiscalYear: (state, action) => {
            state.minFiscalYear = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxFiscalYear: (state, action) => {
            state.maxFiscalYear = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinCompletionFiscalYear: (state, action) => {
            state.minCompletionFiscalYear = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxCompletionFiscalYear: (state, action) => {
            state.maxCompletionFiscalYear = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinObligationFiscalYear: (state, action) => {
            state.minObligationFiscalYear = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxObligationFiscalYear: (state, action) => {
            state.maxObligationFiscalYear = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMinFiscalQuarter: (state, action) => {
            state.minFiscalQuarter = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setMaxFiscalQuarter: (state, action) => {
            state.maxFiscalQuarter = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setInitiationFiscalQuarters: (state, action) => {
            state.initiationFiscalQuarters = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setCompletionFiscalQuarters: (state, action) => {
            state.completionFiscalQuarters = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFilterFeatureSelection: (state, action) => {
            state.filterFeatureSelection = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsDepartmentApproved: (state, action) => {
            state.isDepartmentApproved = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsRegionApproved: (state, action) => {
            state.isRegionApproved = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsAgencyApproved: (state, action) => {
            state.isAgencyApproved = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsLocalApproved: (state, action) => {
            state.isLocalApproved = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsAllApproved: (state, action) => {
            state.isAllApproved = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsNoneApproved: (state, action) => {
            state.isNoneApproved = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsInteragency: (state, action) => {
            state.isInteragency = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsLocationFilterOnly: (state, action) => {
            state.isLocationFilterOnly = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIsGroupingOnly: (state, action) => {
            state.isGroupingOnly = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingDepartment: (state, action) => {
            state.fundingDepartment = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingAgency: (state, action) => {
            state.fundingAgency = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingRegion: (state, action) => {
            state.fundingRegion = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingUnit: (state, action) => {
            state.fundingUnit = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingSubUnit: (state, action) => {
            state.fundingSubUnit = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingTribe: (state, action) => {
            state.fundingTribe = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingUnitType: (state, action) => {
            state.fundingUnitType = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setFundingUnitTypeIgnoreNational: (state, action) => {
            state.fundingUnitTypeIgnoreNational = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setIgnoreContributedOnly: (state, action) => {
            state.ignoreContributedOnly = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setNames: (state, action) => {
            state.names = action.payload;
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        setDataset: (state, action) => {
            state.dataset = action.payload;

            // Existing comment: Side effects are frowned upon in redux, but this is cleaner than endless effect hooks

            // TODO - Refactor: This is a a preexisting issue originally necessary because the downstream
            // functions are called both imperatively outside this function, in a useEffect, and from this store setter
            const expressionStr = getFilterExpressionStringFromRedux(
                { [FieldNames.userFields.nifcUsername]: 'SYSTEM:FilterSlice' },
                state
            );
            state.filterExpression = expressionStr;
            state.definitionExpression = expressionStr;
            // Dataset does not count as a filter directly like the others
            // So no need to recalculate the filter count
        },
        /**
         * Restore the basic filter criteria captured with a saved summary report.
         *
         * The payload is a complete set of criteria assignments — see
         * SummaryReports/utils/filterSnapshot — so a field the report did not set goes back to
         * its initial value rather than keeping whatever the previous report left there.
         *
         * `definitionExpression` is deliberately untouched: the report carries its own, and
         * the view applies it separately. Recalculating the count re-derives `filterExpression`
         * from the restored criteria, which is what the filter UI reads.
         */
        hydrateFilters: (state, action) => {
            Object.entries(action.payload ?? {}).forEach(([key, value]) => {
                state[key] = value;
            });
            filterSlice.caseReducers.recalculateFilterCount(state);
        },
        recalculateFilterCount: (state) => {
            let activeFilterCount = 0;
            activeFilterCount += state.filterProjectValue ? state.filterProjectValue.length : 0;
            activeFilterCount += state.projectDiscoveryDates
                ? state.projectDiscoveryDates.length
                : 0;
            activeFilterCount += state.projectFireCodes ? state.projectFireCodes.length : 0;
            activeFilterCount += state.projectIDs ? state.projectIDs.length : 0;
            activeFilterCount += state.fuelsCategories ? state.fuelsCategories.length : 0;
            activeFilterCount += state.postFireCategories ? state.postFireCategories.length : 0;
            activeFilterCount += state.minDurability ? 1 : 0;
            activeFilterCount += state.maxDurability ? 1 : 0;
            activeFilterCount += state.priorities ? state.priorities.length : 0;
            activeFilterCount += state.activeDrawTool ? 1 : 0;
            activeFilterCount += state.filterGeometry ? 1 : 0;
            activeFilterCount += state.minCalculatedArea ? 1 : 0;
            activeFilterCount += state.maxCalculatedArea ? 1 : 0;
            activeFilterCount += state.calculatedAreaType ? 1 : 0;
            activeFilterCount += state.congressionalDistrict
                ? state.congressionalDistrict.length
                : 0;
            activeFilterCount += state.minInitiationDate ? 1 : 0;
            activeFilterCount += state.maxInitiationDate ? 1 : 0;
            activeFilterCount += state.minCompletionDate ? 1 : 0;
            activeFilterCount += state.maxCompletionDate ? 1 : 0;
            activeFilterCount += state.minEstPersonnelCost ? 1 : 0;
            activeFilterCount += state.maxEstPersonnelCost ? 1 : 0;
            activeFilterCount += state.minEstGrantsFixedCost ? 1 : 0;
            activeFilterCount += state.maxEstGrantsFixedCost ? 1 : 0;
            activeFilterCount += state.minEstAssetCost ? 1 : 0;
            activeFilterCount += state.maxEstAssetCost ? 1 : 0;
            activeFilterCount += state.minEstContractualCost ? 1 : 0;
            activeFilterCount += state.maxEstContractualCost ? 1 : 0;
            activeFilterCount += state.minEstOtherCost ? 1 : 0;
            activeFilterCount += state.maxEstOtherCost ? 1 : 0;
            activeFilterCount += state.minEstTotalCost ? 1 : 0;
            activeFilterCount += state.maxEstTotalCost ? 1 : 0;
            activeFilterCount += state.states ? state.states.length : 0;
            activeFilterCount += state.counties ? state.counties.length : 0;
            activeFilterCount += state.fuelsTypes ? state.fuelsTypes.length : 0;
            activeFilterCount += state.postFireTypes ? state.postFireTypes.length : 0;
            activeFilterCount += state.wbsIds ? state.wbsIds.length : 0;
            activeFilterCount += state.isRTRL ? state.isRTRL.length : 0;
            activeFilterCount += state.isContract ? state.isContract.length : 0;
            activeFilterCount += state.isAgreement ? state.isAgreement.length : 0;
            activeFilterCount += state.status ? state.status.length : 0;
            activeFilterCount += state.isCarryover ? state.isCarryover.length : 0;
            activeFilterCount += state.fundingSources ? state.fundingSources.length : 0;
            activeFilterCount += state.minFiscalYear ? 1 : 0;
            activeFilterCount += state.maxFiscalYear ? 1 : 0;
            activeFilterCount += state.minCompletionFiscalYear ? 1 : 0;
            activeFilterCount += state.maxCompletionFiscalYear ? 1 : 0;
            activeFilterCount += state.minObligationFiscalYear ? 1 : 0;
            activeFilterCount += state.maxObligationFiscalYear ? 1 : 0;
            activeFilterCount += state.minFiscalQuarter ? 1 : 0;
            activeFilterCount += state.maxFiscalQuarter ? 1 : 0;
            activeFilterCount += state.initiationFiscalQuarters
                ? state.initiationFiscalQuarters.length
                : 0;
            activeFilterCount += state.completionFiscalQuarters
                ? state.completionFiscalQuarters.length
                : 0;
            activeFilterCount += state.filterFeatureSelection
                ? state.filterFeatureSelection.length
                : 0;
            activeFilterCount += state.isDepartmentApproved ? 1 : 0;
            activeFilterCount += state.isRegionApproved ? 1 : 0;
            activeFilterCount += state.isAgencyApproved ? 1 : 0;
            activeFilterCount += state.isLocalApproved ? 1 : 0;
            activeFilterCount += state.isInteragency ? 1 : 0;
            activeFilterCount += state.isAllApproved ? 1 : 0;
            activeFilterCount += state.isNoneApproved ? 1 : 0;
            activeFilterCount += state.fundingDepartment ? state.fundingDepartment.length : 0;
            activeFilterCount += state.fundingAgency ? state.fundingAgency.length : 0;
            activeFilterCount += state.fundingRegion ? state.fundingRegion.length : 0;
            activeFilterCount += state.fundingUnit ? state.fundingUnit.length : 0;
            activeFilterCount += state.fundingUnitType ? state.fundingUnitType.length : 0;
            activeFilterCount += state.fundingUnitTypeIgnoreNational ? 1 : 0;
            activeFilterCount += state.ignoreContributedOnly ? 1 : 0;
            activeFilterCount += state.fundingSubUnit ? state.fundingSubUnit.length : 0;
            activeFilterCount += state.fundingTribe ? state.fundingTribe.length : 0;
            activeFilterCount += state.names ? state.names.length : 0;
            state.activeFilterCount = activeFilterCount;
            // Side effects are frowned upon in redux, but this is cleaner than endless effect hooks
            if (state.isBasicFilterActive) {
                // TODO - Refactor: This is a a preexisting issue originally necessary because the downstream
                // functions are called both imperatively outside this function, in a useEffect, and from this store setter
                const expressionStr = getFilterExpressionStringFromRedux(
                    { [FieldNames.userFields.nifcUsername]: 'SYSTEM:FilterSlice' },
                    state
                );
                state.filterExpression = expressionStr;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setCurrentMapViewObj, (state, action) => {
            state.currentMapExtent = action.payload.extent;
            state.currentMapScale = action.payload.scale;
            state.currentMapResolution = action.payload.resolution;
            state.currentMapZoom = action.payload.zoom;
        });
        builder.addCase(setConfig, (state, action) => {
            state.config = action.payload;
        });
        builder.addCase(setRootServiceUrl, (state, action) => {
            state.rootServiceUrl = action.payload;
        });
        builder.addCase(setNifcToken, (state, action) => {
            state.nifcToken = action.payload;
        });
    },
});

export const {
    clearFilters,
    hydrateFilters,
    setIsEstimatedTreatmentQuerying,
    setIsEstimatedActivityQuerying,
    setIsActualTreatmentQuerying,
    setIsActualActivityQuerying,
    setIsPostFireProjectQuerying,
    setIsBasicFilterActive,
    setIsCustomFilterActive,
    setIsRTRL,
    setIsContract,
    setIsAgreement,
    setEstAssetCost,
    setEstOtherCost,
    setEstContractualCost,
    setEstGrantsFixedCost,
    setEstTotalCost,
    setEstPersonnelCost,
    setFundingSources,
    setClass,
    setFuelsType,
    setPostFireType,
    setFilterProjectValue,
    setProjectDiscoveryDates,
    setProjectIDs,
    setProjectFireCodes,
    setPostFireCategories,
    setFuelsCategories,
    setMinDurability,
    setMaxDurability,
    setMinCalculatedArea,
    setMaxCalculatedArea,
    setCalculatedAreaType,
    setCongressionalDistrict,
    setMinInitiationDate,
    setMaxInitiationDate,
    setMinEstPersonnelCost,
    setMaxEstPersonnelCost,
    setMinEstGrantsFixedCost,
    setMaxEstGrantsFixedCost,
    setMinEstAssetCost,
    setMaxEstAssetCost,
    setMinEstContractualCost,
    setMaxEstContractualCost,
    setState,
    setCounty,
    setMinEstOtherCost,
    setMaxEstOtherCost,
    setMinEstTotalCost,
    setMaxEstTotalCost,
    setDefinitionExpression,
    setFilterExpression,
    setMinFiscalYear,
    setMaxFiscalYear,
    setFilterFeatureSelection,
    setActiveDrawTool,
    setFilterGeometry,
    setPriorities,
    setMinCompletionDate,
    setMaxCompletionDate,
    setMinCompletionFiscalYear,
    setMaxCompletionFiscalYear,
    setInitiationFiscalQuarters,
    setCompletionFiscalQuarters,
    setIsDepartmentApproved,
    setIsAgencyApproved,
    setIsRegionApproved,
    setIsLocalApproved,
    setIsAllApproved,
    setIsNoneApproved,
    setStatus,
    setIsLocationFilterOnly,
    setIsGroupingOnly,
    setFundingDepartment,
    setFundingAgency,
    setFundingRegion,
    setFundingUnit,
    setFundingSubUnit,
    setFundingTribe,
    setFundingUnitType,
    setFundingUnitTypeIgnoreNational,
    setCustomFilterCount,
    setIgnoreContributedOnly,
    setWbsIds,
    setNames,
    setIsCarryover,
    setMinObligationFiscalYear,
    setMaxObligationFiscalYear,
    setDataset,
    setIsInteragency,
} = filterSlice.actions;

export default filterSlice.reducer;
